import { QueryClient } from '@tanstack/react-query';
import type { ReduxProxy } from 'v5/api/_common/reduxProxy';
import { callsheetKeys } from './callsheets.hooks';

/**
 * Merging duplicates is a v1-only write that moves the merged-away person's team members to the
 * kept one, on callsheets it doesn't name: every callsheet page reads again, so no team member
 * links to the deleted contact.
 */
export function reconcileCallsheetsWithMergedResources(
  client: QueryClient,
  reduxProxy: Pick<ReduxProxy, 'read'>
) {
  reduxProxy.read.addListener(event => {
    switch (event.type) {
      case 'MERGE_RESOURCE_SUCCESS':
        client.removeQueries({
          type: 'inactive',
          queryKey: callsheetKeys.all()
        });
        void client.invalidateQueries({
          type: 'active',
          queryKey: callsheetKeys.all()
        });
    }
  });
}
